import { combineReducers, configureStore } from '@reduxjs/toolkit';

import swapReducer from '../features/swapSlice';

const reducers = combineReducers({
  swap: swapReducer,
});

export const store = configureStore({
  reducer: reducers,
});

type RootState = ReturnType<typeof store.getState>;

export const selectTokensUserOne = (state: RootState) => state.swap.swapTokensUserOne;

export const selectTokensUserTwo = (state: RootState) => state.swap.swapTokensUserTwo;
